
import { Component, Vue } from 'vue-property-decorator';
import axios from "axios";
import {MstContentsVO} from "@/views/biz/introduction/vo/contents.vo";

declare type CsItem = {
    itemCd: string;
    itemNm: string;
}

@Component
export default class ProductDeliveryInfo1 extends Vue {
    contents: MstContentsVO = {} as MstContentsVO;

    get getContents() {
        return this.contents;
    }

    // initialized events
    created(): void {
      // 23 : 싱픔 상세 배송 및 세금 설명
      axios.get(`/common/contents/043003/044007`)
            .then(r => {
                this.contents = r.data;
            })
    }
}
